import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["component", "to", "replace", "onClick"];
import { useMemo, useCallback, createElement } from 'react';
import { useHistory, createLocation } from 'quartz-routing/react-router';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
const AbstractRouterLink = props => {
  const {
      component,
      to = '',
      replace = false,
      onClick
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const history = useHistory();
  const handleClick = useCallback(e => {
    callIfPossible(onClick, e);
    if (e.defaultPrevented) {
      return;
    }
    if (e && !e.metaKey) {
      e.preventDefault();
      if (replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    }
  }, [history, onClick, replace, to]);
  const href = useMemo(() => {
    const location = typeof to === 'string' || to === null ? createLocation(to || '', null, undefined, history.location) : to;
    return history.createHref(location);
  }, [history, to]);
  return /*#__PURE__*/createElement(component, Object.assign({}, rest, {
    href,
    onClick: handleClick
  }));
};
export default AbstractRouterLink;